<!-- 一般ユーザー　新規健保予約画面-->
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<template>
  <div class="container" id="step00">
    <div class="contents">
      <h2>健診予約</h2>
      <section class="flow">
        <h3>予約申し込みの流れ</h3>
        <ol>
          <li>コース選択</li>
          <li>オプション選択</li>
          <li>受診日時選択</li>
          <li>予約情報入力</li>
          <li>予約情報入力</li>
          <li>予約確定</li>
        </ol>
      </section>
      <section id="mainContents">
        <section class="inputArea">
          <h3>【受診者様情報入力】</h3>
          <p>受診者様ご本人の連絡先等を入力してください。</p>
          <p>当院と契約のある健康保険組合・企業にご加入されている方で、費用の補助を受けて受診される方が対象です。</p>
          <table>
            <tbody>
              <tr>
                <th>健康保険組合名</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.jgcdMessage"></errorMessageBalloon>
                  <select v-model="inputForm.jgcd" v-on:change="reactiveValidationJgcd">
                    <option value="">選択してください</option>
                    <option v-for="item in inputForm.listJgyo" v-bind:value="item.jgcd" v-bind:key="item.jgcd">
                      {{item.jgnm}}
                    </option>
                  </select>
                  <div class="note komeM">ご加入の健康保険組合が選択できない場合は、「健保制度を利用せず個人として新規予約」よりご予約ください。</div>
                </td>
              </tr>
              <tr>
                <th>保険者番号</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hkshMessage"></errorMessageBalloon>
                  <input type="text" placeholder="00123456" maxlength="8" v-model="inputForm.hksh" v-on:change="reactiveValidationHksh">
                  <div class="note komeM">保険者番号が8桁未満の方は左詰めに「0」を入れて8桁にしてください。<br>例）実際の保険者番号：123456 → 入力する場合：00123456</div>
                </td>
              </tr>
              <tr>
                <th>性別</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.sexMessage"></errorMessageBalloon>
                  <label class="radio"><input type="radio" v-bind:value="inputForm.codeSexMan" v-model="inputForm.sex" v-on:change="reactiveValidationSex"><span>男性</span></label>
                  <label class="radio"><input type="radio" v-bind:value="inputForm.codeSexWoman" v-model="inputForm.sex" v-on:change="reactiveValidationSex"><span>女性</span></label>
                </td>
              </tr>
              <tr>
                <th>生年月日</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.btdyMessage"></errorMessageBalloon>
                  <ul class="dayForm">
                    <li>
                      <select v-model="inputForm.btdyYear" v-on:change="reactiveValidationBtdy">
                        <option value=0>選択</option>
                        <option v-for="item in inputForm.listBtdyYear" v-bind:key="item">
                          {{item}}
                        </option>
                      </select>
                    </li>
                    <li>
                      <select v-model="inputForm.btdyMonth" v-on:change="reactiveValidationBtdy">
                        <option value=0>選択</option>
                        <option v-for="item in inputForm.listBtdyMonth" v-bind:key="item">
                          {{item}}
                        </option>
                      </select>
                    </li>
                    <li>
                      <!-- 選んだ生年月日　年及び月に依存 -->
                      <select v-model="inputForm.btdyDate" v-on:change="reactiveValidationBtdy">
                        <option value=0>選択</option>
                        <option v-for="item in computedListBtdyDate" v-bind:key="item">
                          {{item}}
                        </option>
                      </select>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th>受診年度</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.nendMessage"></errorMessageBalloon>
                  <!-- 選んだ健康保険組合（クライアント）に依存 -->
                  <select v-model="inputForm.nend" v-on:change="reactiveValidationNend">
                    <option value=0>選択してください</option>
                    <option v-for="item in filteredListIrks" v-bind:value="item.nend" v-bind:key="item.nend">
                      {{item.nend}}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <th>対象者区分</th>
                <td>
                  <errorMessageBalloon :errorMessages="reactiveValidationError.hfkbMessage"></errorMessageBalloon>
                  <!-- 選んだ健康保険組合（クライアント）に依存 -->
                  <select v-model="inputForm.hfkb" v-on:change="reactiveValidationHfkb">
                    <option value="">選択してください</option>
                    <option v-for="item in filteredListHfkb" v-bind:value="item.hfkb" v-bind:key="item.hfkb">
                      {{item.kbnm}}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        <div class="btnLst"><button class="nextBtn" v-on:click="onNext">予約する</button></div>
        </section>
        <div class="btnLst">
        	<button class="backBtn" v-on:click="onBack">戻る</button>
        </div>
      </section>
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
        <dt slot="modal-header">入力エラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
      <!-- モーダルWindow S -->
      <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
        <dt slot="modal-header">システムエラー</dt>
        <dd slot="modal-body">
          <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
        </dd>
        <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
      </modalWindow>
      <!-- モーダルWindow E -->
    </div>
  </div>
</template>
<script>
  import { CommonNewHealthInsurance } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBalloon from '@/components/Utility/ErrorMessageBalloon'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonNewHealthInsurance',
    // 使用コンポーネント
    components: {
      // エラーバルーン（リアクティブエラー表示）
      errorMessageBalloon: ErrorMessageBalloon,
      // エラー表示コンポーネント
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      modalWindow: ModalWindow
    },
    // 算出プロパティ
    computed: {
      // クライアントでフィルタされた受診年度
      filteredListIrks: function () {

        var tempListIrks = []

        if (this.inputForm.jgcd != '') {
          tempListIrks = this.inputForm.listIrks
            .filter(item => {
              return item.jgcd == this.inputForm.jgcd
            })
        } else {
          tempListIrks = []
        }
        return tempListIrks;
      },
      // クライアントでフィルタされた対象者区分
      filteredListHfkb: function () {

        var tempListHfkb = []

        if (this.inputForm.jgcd != '') {
          tempListHfkb = this.inputForm.listHfkb
            .filter(item => {
              return item.jgcd == this.inputForm.jgcd
            })
        } else {
          tempListHfkb = []
        }
        return tempListHfkb;
      },
      // 生年月日　日付のプルダウン内容を生成
      computedListBtdyDate: function () {

        var tempListBtdyDate = []

        // 当月の最終日の求め方
        // 本来8月なら第二引数（月）は7を与えるべきだが
        // 本来8月なら第三引数（日）に0を与えて
        // 次月の最初の日（1日）より一日前（0日）で
        // 当月の最終日を求める
        var lastDate = new Date(
          this.inputForm.btdyYear,
          this.inputForm.btdyMonth, 0).getDate()

        for (var i = 1; i <= lastDate; i++) {
          tempListBtdyDate.push(i)
        }

        return tempListBtdyDate
      }
    },
    // 監視プロパティ
    watch: {
      // 健康保険組合名の選択値（クライアントコード）を監視
      'inputForm.jgcd': function (newJgcd, oldJgcd) {

        // 健康保険組合名の選択値に変更があれば
        // 初期値に戻す
        // なお初回表示oldJgcdが空文字の時は（ストアから値を引き継ぐため）処理しない
        if(oldJgcd != '' ){
          this.inputForm.nend = 0
          this.inputForm.hfkb = ''
        }

      },
    },
    // データ
    data() {
      return {

        // ユーザータイプ
        userType: '0',
        // 1: マイページ経由かつ新規予約（健保）
        codeUserTypeMyPageNewHealth: '1',
        // 3: マイページ経由かつ予約変更（健保）
        codeUserTypeMyPageChangeHealth: '3',
        // 5: ゲストログインかつ新規予約（健保）
        codeUserTypeGuestNewHealth: '5',

        // 入力フォーム
        inputForm: {
          // 健康保険組合名の選択値（クライアントコード）
          jgcd: '',
          // 健康保険組合名　プルダウン内容
          // jgcd:クライアントコード
          // jgnm:クライアント名
          listJgyo:[],
          // 保険者番号
          hksh: '',
          // 性別の選択値 1:男、2:女
          sex: '',
          // 性別 男のコード値
          codeSexMan: '1',
          // 性別 女のコード値
          codeSexWoman: '2',
          // 生年月日　年
          btdyYear: 0,
          // 生年月日　月
          btdyMonth: 0,
          // 生年月日　日付
          btdyDate: 0,
          // 生年月日　年のプルダウン内容
          listBtdyYear:[],
          // 生年月日　月のプルダウン内容
          listBtdyMonth: [
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
          ],
          // 受診年度の選択値
          nend: 0,
          // 受診年度のプルダウン内容
          // nend:年度
          // jgcd:クライアントコード
          listIrks:[],
          // 対象者区分
          hfkb: '',
          // 対象者区分のプルダウン内容
          // jgcd:クライアントコード
          // hfkb:対象者区分コード
          // kbnm:対象者区分名
          listHfkb:[],
        },
        // リアクティブエラー
        reactiveValidationError: {

          // クライアントコード
          // エラーメッセージ
          jgcdMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          jgcdInputFlag: false,

          // 保険者番号
          // エラーメッセージ
          hkshMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hkshInputFlag: false,

          // 性別
          // エラーメッセージ
          sexMessageList: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          sexInputFlag: false,

          // 生年月日
          // エラーメッセージ
          btdyMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          btdyYearInputFlag: false,
          btdyMonthInputFlag: false,
          btdyDateInputFlag: false,

          // 年度
          // エラーメッセージ
          nendMessageList: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          nendInputFlag: false,

          // 対象者区分
          // エラーメッセージ
          hfkbMessage: '',
          // 入力済みフラグ（一度でも入力しているかどうか）
          hfkbInputFlag: false,

        },
        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // ライフサイクルフック: created
    created: function () {
      UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::created End')
    },
    methods: {
      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::firstDisplay Start')

        // ユーザータイプの取得
        this.userType = this.getUserType()

        // 各プルダウンの初期値を取得する
        CommonNewHealthInsurance.FirstDisplay({
          ircd: this.$store.state.auth.ircd
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.inputForm.listJgyo = responce.data.listJgyo
            this.inputForm.listBtdyYear = responce.data.listBirthYear
            this.inputForm.listIrks = responce.data.listIrks
            this.inputForm.listHfkb = responce.data.listHfkb

            // ストアに値がある場合は引き継ぐ
            this.successionFormDataFromStore()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::firstDisplay End')
	      })
      },
      // 表示系--------------------------------------------------E
      // イベント系--------------------------------------------------S
      // 予約する
      onNext: function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onNext Start')

        var errorMessagesList = this.validationOnNext()

        if (errorMessagesList.length > 0) {
          this.onValidationErrorModalOpen(errorMessagesList)
          UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onNext End')
          return;
        }

        // 相関チェックを行い、年齢を算出する
        CommonNewHealthInsurance.Next({
          ircd: this.$store.state.auth.ircd,
          hksh: this.inputForm.hksh,
          jgcd: this.inputForm.jgcd,
          sex:  this.inputForm.sex,
          btdyYear: this.inputForm.btdyYear,
          btdyMonth: this.inputForm.btdyMonth,
          btdyDate: this.inputForm.btdyDate,
          nend: this.inputForm.nend,
          hfkb: this.inputForm.hfkb
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // サーバーで算出した年齢の登録
            this.$store.commit(
              types.COMMON_NEWHEALTHINSURANCE,
              {
                jgcd: this.inputForm.jgcd,
                hksh: this.inputForm.hksh,
                sex: this.inputForm.sex,
                btdyYear: this.inputForm.btdyYear,
                btdyMonth: this.inputForm.btdyMonth,
                btdyDate: this.inputForm.btdyDate,
                nend: this.inputForm.nend,
                age: responce.data.age,
                hfkb: this.inputForm.hfkb
              })

            // コース一覧に遷移
            this.$router.push("/CommonSelectCourse")

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {

            this.onValidationErrorModalOpen(responce.data.errorMessagesList)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {

            // エラーメッセージリストを作成し、エラーを表示
            var errorMessagesList = []
            errorMessagesList.push(responce.data.errorMessage)
            this.onValidationErrorModalOpen(errorMessagesList)

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            this.onSystemErrorModalOpen()
          }

        }).catch(() => {
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onNext End')
	      })
      },
      // 戻るボタン押下時
      onBack: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onBack Start')

        // ユーザータイプ毎にストア値のリセットするミューテーションと
        // 戻り遷移先を変更する
        var tempUserType = this.getUserType()

        if(this.codeUserTypeMyPageNewHealth == tempUserType) {
          // 1: マイページ経由かつ新規予約（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE1)

          // マイページ画面へ遷移
          this.$router.push("/CommonMyPage")

        } else if(this.codeUserTypeMyPageChangeHealth == tempUserType) {
          // 3: マイページ経由かつ予約変更（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE3)

          // マイページ画面へ遷移
          this.$router.push("/CommonMyPage")

        } else if(this.codeUserTypeGuestNewHealth == tempUserType) {
          // 5: ゲストログインかつ新規予約（健保）

          // ストアの値をリセット
          this.$store.commit(
            types.COMMON_NEWHEALTHINSURANCE_BACK_USERTYPE5)

				  // URLパラム
				  var tempParam = this.$store.getters.getCommonParam

          // トップ画面へ遷移
          this.$router.push('/CommonTop/' + tempParam)
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onBack End')
      },
      // イベント系--------------------------------------------------E
      // その他--------------------------------------------------S
      // ストア値などからユーザータイプを取得
      getUserType: function() {

      	UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::getUserType Start')

      	var resultUserType = ''

      	// マイページ経由、ゲストログイン、途中ログインかどうか
      	if(this.$store.state.commonUserInfo.myPage.isUse) {
      		// マイページ経由

      		// 新規予約か予約変更どうか
      		if(this.$store.state.commonUserInfo.myPage.choiceUkno == '') {
      			// 新規予約
      			resultUserType = this.codeUserTypeMyPageNewHealth
      		} else {
      			// 予約変更
      			resultUserType = this.codeUserTypeMyPageChangeHealth
      		}
      	} else {
      		// ゲストログイン（マイページ経由、ゲストログイン、途中ログイン）
      		resultUserType = this.codeUserTypeGuestNewHealth
      	}
      	UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::getUserType End')

      	return resultUserType
      },
      // リアクティブエラー処理 クライアントコード
      reactiveValidationJgcd:function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationJgcd Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.jgcdInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.jgcd)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.jgcdInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationJgcd()
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.jgcdMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.jgcdMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationJgcd End')
      },
      // リアクティブエラー処理 保険者番号
      reactiveValidationHksh:function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationHksh Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hkshInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hksh)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hkshInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHksh()
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hkshMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hkshMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationHksh End')
      },
      // リアクティブエラー 性別
      reactiveValidationSex:function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationSex Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.sexInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.sex)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.sexInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationSex()
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.sexMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.sexMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationSex End')
      },
      // リアクティブエラー 生年月日
      reactiveValidationBtdy:function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationBtdy Start')

        var tempErrorMessage = []
        var tempErrorMessageBtdyYear = []
        var tempErrorMessageBtdyMonth = []
        var tempErrorMessageBtdyDate = []

        // 生年月日 年 一度も入力していない場合
        if(!this.reactiveValidationError.btdyYearInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyYear)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyYearInputFlag = true
          }
        }

        // 生年月日 月 一度も入力していない場合
        if(!this.reactiveValidationError.btdyMonthInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyMonth)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyMonthInputFlag = true
          }
        }

        // 生年月日 日 一度も入力していない場合
        if(!this.reactiveValidationError.btdyDateInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.btdyDate)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.btdyDateInputFlag = true
          }
        }

        // 必須項目のうち一度も入力していない項目が一つでもある場合
        if(!this.reactiveValidationError.btdyDateInputFlag
            || !this.reactiveValidationError.btdyMonthInputFlag
            || !this.reactiveValidationError.btdyDateInputFlag) {
            return
        }

        // リアクティブエラーチェック　生年月日 年
        tempErrorMessageBtdyYear = this.validationBtdyYear()
        tempErrorMessageBtdyYear.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　生年月日 月
        tempErrorMessageBtdyMonth = this.validationBtdyMonth()
        tempErrorMessageBtdyMonth.forEach(
          item => tempErrorMessage.push(item)
        )

        // リアクティブエラーチェック　生年月日 日
        tempErrorMessageBtdyDate = this.validationBtdyDate()
        tempErrorMessageBtdyDate.forEach(
          item => tempErrorMessage.push(item)
        )

        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.rykMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.rykMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationBtdy End')
      },
      // リアクティブエラー 受診年度
      reactiveValidationNend:function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationNend Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.nendInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.nend)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.nendInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationNend()
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.nendMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.nendMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationNend End')

      },
      // リアクティブエラー 対象者区分
      reactiveValidationHfkb:function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationHfkb Start')

        var tempErrorMessage = []

        // 一度も入力していない場合
        if(!this.reactiveValidationError.hfkbInputFlag) {

          if(UtilityValidation.checkStrIsKaraMoji(this.inputForm.hfkb)) {
            // 空文字ならば処理終了
            return
          } else {
            // 空文字でないなら入力済みに設定する
            this.reactiveValidationError.hfkbInputFlag = true
          }
        }

        // リアクティブエラーチェック
        tempErrorMessage = this.validationHfkb()
        if (tempErrorMessage.length > 0) {
          this.reactiveValidationError.hfkbMessage = tempErrorMessage[0]
        } else {
          this.reactiveValidationError.hfkbMessage = ''
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::reactiveValidationHfkb End')

      },
      // 予約するボタン押下時入力チェック
      validationOnNext: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationOnNext Start')

        // エラーメッセージリスト
        var errorMessagesList = []

        var tempErrorMessage = []
        // 健康保険組合名入力チェック
        tempErrorMessage = this.validationJgcd()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 保険者番号入力チェック
        tempErrorMessage = this.validationHksh()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 性別の入力チェック
        tempErrorMessage = this.validationSex()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 生年月日の入力チェック
        tempErrorMessage = this.validationBtdyYear()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        tempErrorMessage = this.validationBtdyMonth()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        tempErrorMessage = this.validationBtdyDate()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 受診年度の入力チェック
        tempErrorMessage = this.validationNend()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })
        // 対象者区分
        tempErrorMessage = this.validationHfkb()
        tempErrorMessage.forEach((item) => {
          errorMessagesList.push(item)
        })

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationOnNext End')

        return errorMessagesList
      },
      // 健康保険組合名入力チェック
      validationJgcd: function() {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationJgcd Start')

        var propertyNameJgcd = '健康保険組合名'

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.inputForm.jgcd)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameJgcd))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.jgcd)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNameJgcd))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationJgcd End')

        return errorMessagesList
      },
      // 保険者番号入力チェック
      validationHksh: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationHksh Start')

        var propertyNameHksh = '保険者番号'
        var lengthHksh = 8

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.inputForm.hksh)) { // Nullチェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameHksh))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hksh)) { // 空文字チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNameHksh))
        } else if (!UtilityValidation.checkStrLength(this.inputForm.hksh, lengthHksh)) { // 桁数チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrLength(
              propertyNameHksh, String(lengthHksh)))
        } else if (!UtilityValidation.checkStrHalfWidthNumeric(this.inputForm.hksh)) { // 半角数字チェック

          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrHalfWidthNumeric(
              propertyNameHksh))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationHksh End')

        return errorMessagesList
      },
      // 性別の入力チェック
      validationSex: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationSex Start')

        var propertyNameSex = '性別'

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.inputForm.sex)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameSex))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.sex)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNameSex))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationSex End')

        return errorMessagesList
      },
      // 生年月日　年の入力チェック
      validationBtdyYear: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyYear Start')

        var propertyName = '生年月日　年'

        // エラーメッセージリスト
        var errorMessagesList = []

        // 初期値
        if (this.inputForm.btdyYear == 0 ) {
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyName))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyYear End')

        return errorMessagesList
      },
      // 生年月日　月の入力チェック
      validationBtdyMonth: function (in_checkType) {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyMonth Start')

        var propertyName = '生年月日　月'

        // エラーメッセージリスト
        var errorMessagesList = []

        // 初期値
        if (this.inputForm.btdyMonth == 0 ) {
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyName))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyMonth End')

        return errorMessagesList
      },
      // 生年月日　日の入力チェック
      validationBtdyDate: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyDate Start')

        var propertyName = '生年月日　日'

        // エラーメッセージリスト
        var errorMessagesList = []

        // 初期値
        if (this.inputForm.btdyDate == 0 ) {
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyName))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationBtdyDate End')

        return errorMessagesList
      },
      // 受診年度の入力チェック
      validationNend: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationNend Start')

        var propertyNameNend = '受診年度'

        // エラーメッセージリスト
        var errorMessagesList = []

        if (this.inputForm.nend == 0) { // 初期値
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameNend))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationNend End')

        return errorMessagesList
      },
      // 対象者区分の入力チェック
      validationHfkb: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationHfkbHfkb Start')

        var propertyNameHfkb = '対象者区分'

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.inputForm.hfkb)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameHfkb))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.inputForm.hfkb)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNameHfkb))
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::validationHfkbHfkb End')

        return errorMessagesList
      },
      // ストア値の引継ぎ
      successionFormDataFromStore: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::successionFormDataFromStore Start')

        if (this.$store.state.commonUserInfo.newHealthInsurance.jgcd != null
          && this.$store.state.commonUserInfo.newHealthInsurance.jgcd != '') {
          this.inputForm.jgcd = this.$store.state.commonUserInfo.newHealthInsurance.jgcd
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.hksh != null
          && this.$store.state.commonUserInfo.newHealthInsurance.hksh != '') {
          this.inputForm.hksh = this.$store.state.commonUserInfo.newHealthInsurance.hksh
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.sex != null
          && this.$store.state.commonUserInfo.newHealthInsurance.sex != '') {
          this.inputForm.sex = this.$store.state.commonUserInfo.newHealthInsurance.sex
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.btdyYear != 0) {
          this.inputForm.btdyYear = this.$store.state.commonUserInfo.newHealthInsurance.btdyYear
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.btdyMonth != 0) {
          this.inputForm.btdyMonth = this.$store.state.commonUserInfo.newHealthInsurance.btdyMonth
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.btdyDate != 0) {
          this.inputForm.btdyDate = this.$store.state.commonUserInfo.newHealthInsurance.btdyDate
        }

        if(this.$store.state.commonUserInfo.newHealthInsurance.nend != 0) {
          this.inputForm.nend = this.$store.state.commonUserInfo.newHealthInsurance.nend
        }

        if (this.$store.state.commonUserInfo.newHealthInsurance.hfkb != null
          && this.$store.state.commonUserInfo.newHealthInsurance.hfkb != '') {
          this.inputForm.hfkb = this.$store.state.commonUserInfo.newHealthInsurance.hfkb
        }

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::successionFormDataFromStore End')
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]

				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onSystemErrorModalClose Start')

        this.modalClose('systemError')

				// URLパラム
				var tempParam = this.$store.getters.getCommonParam

				// トップ画面へ遷移
				this.$router.push('/CommonTop/' + tempParam)

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('CommonNewHealthInsurance::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			},
      // その他--------------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/NewHealthInsurance/CommonNewHealthInsurance.vue